import Axios, { AxiosResponse } from "axios";

const paymentApi = Axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_API_URL,
  timeout: 15000,
});

let providersCatalogCached: AxiosResponse<unknown> | null = null;
let providersCatalogInFlight: Promise<AxiosResponse<unknown>> | null = null;

async function fetchProvidersCatalog(): Promise<AxiosResponse<unknown>> {
  const response = await paymentApi.get(`/v1/providers?types=LocalPayment`);
  providersCatalogCached = response;
  return response;
}

export async function getProviders(merchantId: string) {
  return paymentApi.get(`/v1/merchants/${merchantId}/providers`);
}

export async function getProvidersCatalog(): Promise<AxiosResponse<unknown>> {
  if (providersCatalogCached) {
    return providersCatalogCached;
  }
  if (!providersCatalogInFlight) {
    providersCatalogInFlight = fetchProvidersCatalog();
  }
  try {
    return await providersCatalogInFlight;
  } finally {
    providersCatalogInFlight = null;
  }
}

export async function createProvider({
  merchantId,
  data,
}: {
  merchantId: string;
  data: unknown;
}) {
  return paymentApi.post(`/v1/merchants/${merchantId}/providers`, data);
}

export async function updateProvider({
  merchantId,
  providerId,
  data,
}: {
  merchantId: string;
  providerId: string;
  data: unknown;
}) {
  return paymentApi.put(
    `/v1/merchants/${merchantId}/providers/${providerId}`,
    data,
  );
}

export default paymentApi;
